(() => {
  if (window.ssCardGalleryLoaded) return;
  window.ssCardGalleryLoaded = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = root => {
    if (root.dataset.ssGalleryReady) return;
    const track = root.querySelector('[data-ss-gallery-track]');
    const slides = [...root.querySelectorAll('[data-ss-gallery-slide]')];
    if (!track || slides.length < 2) return;
    root.dataset.ssGalleryReady = 'true';
    const controls = root.querySelector('[data-ss-gallery-controls]');
    const dots = [...root.querySelectorAll('[data-ss-gallery-dot]')];
    const previous = root.querySelector('[data-ss-gallery-previous]');
    const next = root.querySelector('[data-ss-gallery-next]');
    let active = 0;
    let frame = 0;
    let gesture = null;
    let suppressUntil = 0;
    const update = () => {
      const width = track.clientWidth;
      if (!width) return;
      active = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
      const start = Math.max(0, Math.min(active - 2, dots.length - 5));
      dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === active ? 'true' : 'false');
        dot.hidden = dots.length > 5 && (index < start || index >= start + 5);
      });
      previous.disabled = active === 0;
      next.disabled = active === slides.length - 1;
    };
    const goTo = (index, smooth = true) => {
      const target = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({left: target * track.clientWidth, behavior: smooth && !reducedMotion.matches ? 'smooth' : 'instant'});
      if (!smooth || reducedMotion.matches) update();
    };
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
    previous.addEventListener('click', () => goTo(active - 1));
    next.addEventListener('click', () => goTo(active + 1));
    track.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {frame = 0; update();});
    }, {passive: true});
    track.addEventListener('keydown', event => {
      const targets = {ArrowLeft: active - 1, ArrowRight: active + 1, Home: 0, End: slides.length - 1};
      if (!(event.key in targets)) return;
      event.preventDefault();
      goTo(targets[event.key]);
    });
    track.addEventListener('pointerdown', event => {
      if (event.button !== 0) return;
      gesture = {id: event.pointerId, type: event.pointerType, x: event.clientX, y: event.clientY, left: track.scrollLeft, horizontal: false};
    }, {passive: true});
    track.addEventListener('pointermove', event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (!gesture.horizontal && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        gesture.horizontal = true;
        suppressUntil = performance.now() + 600;
        if (gesture.type === 'mouse') {
          track.setPointerCapture(event.pointerId);
          root.classList.add('is-dragging');
        }
      }
      if (gesture.horizontal && gesture.type === 'mouse') {
        event.preventDefault();
        track.scrollLeft = gesture.left - dx;
      }
    });
    const endGesture = event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const last = gesture;
      gesture = null;
      root.classList.remove('is-dragging');
      if (last.horizontal) {
        suppressUntil = performance.now() + 450;
        if (last.type === 'mouse') goTo(Math.round(track.scrollLeft / track.clientWidth));
      }
    };
    track.addEventListener('pointerup', endGesture);
    track.addEventListener('pointercancel', endGesture);
    track.addEventListener('dragstart', event => event.preventDefault());
    track.addEventListener('click', event => {
      if (performance.now() < suppressUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    new ResizeObserver(() => {goTo(active, false); update();}).observe(track);
    controls.hidden = false;
    update();
  };
  const scan = scope => {
    if (scope.matches?.('[data-ss-card-gallery]')) initialize(scope);
    scope.querySelectorAll?.('[data-ss-card-gallery]').forEach(initialize);
  };
  const start = () => {
    scan(document);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1) scan(node);
      }));
    }).observe(document.body, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
